module.exports = __webpack_public_path__ + "img/shebei.b1df0b9d.jpg";